import angular from 'angular';
import mycrmHome from './mycrmHome';

export default angular
  .module('components.mycrmHome', [])
  .component('mycrmHome', mycrmHome).name;
